import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	INPUTS: '.form-group input:not([type=radio]):not([type=file]):not([type=checkbox]):not([disabled])',
	TEXTAREAS: 'textarea',
	SELECTS: 'select',
	DISABLED: '*[disabled]',
	REQUIRED: '*[required], *[data-required]',
};

class FloatingLabelsComponent extends WebComponent {

	constructor(props) {
		super(props);
		const {
			focusOnInput
		} = props;
		this.state = {
			focusOnInput: focusOnInput || ''
		};
	}

	didMount() {

		this.inputsElement = this.element.querySelectorAll(fragments.INPUTS);
		this.textareasElement = this.element.querySelectorAll(fragments.TEXTAREAS);
		this.selectsElement = this.element.querySelectorAll(fragments.SELECTS);
		this.disabledElement = this.element.querySelectorAll(fragments.DISABLED);
		this.requiredElement = this.element.querySelectorAll(fragments.REQUIRED);

		// window.addEventListener("load", this.initLabels);
		let _self = this;
		/**
		 * set timeot to make sure esp target content is found and form elements can be reinitiated
		 */
		setTimeout(function(){
			for (let i = 0; i < _self.inputsElement.length; i++) {
				_self.initLabels(_self.inputsElement[i]);
				// when you type register for oninput
				_self.inputsElement[i].addEventListener('input', _self.typeHandler);
				_self.inputsElement[i].addEventListener('focus', _self.focusHandler);
				_self.inputsElement[i].addEventListener('blur', _self.blurHandler);
				// for IE8
				_self.inputsElement[i].addEventListener('propertychange', _self.typeHandler);
				// fallback for Firefox for <select><option>, for <input> oninput is enough
				// inputs[i].addEventListener('change', typeHandler)
			}

			for (let i = 0; i < _self.textareasElement.length; i++) {
				_self.initLabels(_self.textareasElement[i]);
				_self.textareasElement[i].addEventListener('input', _self.typeHandler);
				_self.textareasElement[i].addEventListener('focus', _self.focusHandler);
				_self.textareasElement[i].addEventListener('blur', _self.blurHandler);
				_self.textareasElement[i].addEventListener('propertychange', _self.typeHandler);
			}

			for (let i = 0; i < _self.selectsElement.length; i++) {
				_self.initLabels(_self.selectsElement[i]);
				_self.selectsElement[i].addEventListener('input', _self.typeHandler);
				_self.selectsElement[i].addEventListener('propertychange', _self.typeHandler);
			}

			for (let i = 0; i < _self.disabledElement.length; i++) {
				_self.initLabels(_self.disabledElement[i]);
			}
		},200);

		if(this.state.focusOnInput !== '') {
			const focusOnInputEl = this.element.querySelector("#" + this.state.focusOnInput);
			if(focusOnInputEl) {
				focusOnInputEl.focus();
				const rangeLength = focusOnInputEl.value.length;
				focusOnInputEl.setSelectionRange(rangeLength, rangeLength);
			}
		}
	}

	initLabels = (element) => {
		let fG = element.closest('.form-group');
		if (fG) {
			if (element.value === "" && !element.disabled) {
				fG.classList.add('form-group--label-hidden');
				fG.classList.remove('form-group--label-visible');
			} else {
				 if(element.type !== 'checkbox') {
					fG.classList.add('form-group--label-visible');
					fG.classList.remove('form-group--label-hidden');
				 }
			}
		}
	};

	typeHandler = (e) => {
		let fG = e.target.closest('.form-group');
		if (fG) {
			if (e.target.value === "") {
				fG.classList.add('form-group--label-hidden');
				fG.classList.remove('form-group--label-visible');
			} else {
				fG.classList.add('form-group--label-visible');
				fG.classList.remove('form-group--label-hidden');
			}
		}
	};

	focusHandler = (e) => {
		let fG = e.target.closest('.form-group');
		if (fG) {
			fG.classList.add('form-group--label-visible');
			fG.classList.remove('form-group--label-hidden');
		}
	};

	blurHandler = (e) => {
		let fG = e.target.closest('.form-group');
		if (fG) {
			if (e.target.value === "") {
				fG.classList.add('form-group--label-hidden');
				fG.classList.remove('form-group--label-visible');
			}
		}
	};

}

export default FloatingLabelsComponent;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/FloatingLabelsComponent.js